import Input from "../../Medicine-master/Component/Input";

export const ConsultantInput = [
  {
    tag: Input,
    img: "",
    label: "Branch Name",
    name: "branchName",
    validation: "required",
    required: true,
    key: "branchName",
    role: "super_admin", // Show this input only for 'super admin' role
  },
  {
    tag: Input,
    img: "",
    label: "Consultant Name",
    name: "consultantName",
    validation: "required",
    key: "consultantName",
    // No role, so this will be shown for all users
  },
  {
    tag: Input,
    img: "",
    label: "Speciality",
    name: "speciality",
    validation: "required",
    key: "speciality",
    // No role, so this will be shown for all users
  },
  {
    tag: Input,
    img: "",
    label: "Email",
    name: "email",
    validation: "required",
    key: "email",
    // No role, so this will be shown for all users
  },
  {
    tag: Input,
    img: "",
    label: "Password",
    name: "password",
    validation: "required",
    required: true,
    key: "password",
    // No role, so this will be shown for all users
  },
  {
    tag: Input,
    img: "",
    label: "Phone 1",
    name: "phone1",
    validation: "required",
    key: "phone1",
    // No role, so this will be shown for all users
  },
  {
    tag: Input,
    img: "",
    label: "Phone 2",
    name: "phone2",
    key: "phone2",
    // No role, so this will be shown for all users
  },
  {
    tag: Input,
    img: "",
    label: "Revenue",
    name: "revenue",
    key: "revenue",
    validation: "required",
    // No role, so this will be shown for all users
  },
  {
    tag: Input,
    img: "",
    label: "Languages",
    name: "languagesSpokenId",
    key: "languagesSpokenId",
    // No role, so this will be shown for all users
  },
  {
    tag: Input,
    img: "",
    label: "Other Languages",
    name: "languagesOthers",
    key: "languagesOthers",
    // No role, so this will be shown for all users
  },
];


export const ConsultantDetailsList = [
  { img: "school", label: "Speciality", name: "speciality" },
  { img: "translate", label: "Languages", name: "languagesName" },
  { break: true },
  { title: "Contact information" },
  { img: "phone", label: "Phone", name: "phone1" },
  { img: "phone", label: "Phone 1", name: "phone2" },
  { img: "email", label: "emailId", name: "email" },
  { break: true },
  { title: "Others" },

];
